import { AudioPlayer, Button, Container, LabeledValue } from 'components/atoms';
import { MoleculeButton } from 'components/molecules';
import { format } from 'date-fns';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { ChangeEvent, useRef } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PiFileAudio, PiTrash, PiWaveform } from 'react-icons/pi';
import { ITrackMutationForm } from 'services/tracks/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { readableFileSize } from 'utils/components/inputs/file';
import { getFileExtension } from 'utils/global/file.utils';

const TrackFile = () => {
  const {
    values,
    status,
    setFieldValue,
  }: IFormikContextType<ITrackMutationForm> =
    useFormikContext<ITrackMutationForm>();

  const inputRef = useRef<HTMLInputElement>(null);

  const { t } = useTranslation();

  const onDeleteTrack = async () => {
    if (!values.mp3Link && !values.mp3PreviewLink && !values.wavLink) {
      setFieldValue('file', undefined);
    }

    if (
      values.mp3Link &&
      values.mp3PreviewLink &&
      values.wavLink &&
      !values.file
    ) {
      setFieldValue('mp3Link', undefined);
      setFieldValue('mp3PreviewLink', undefined);
      setFieldValue('wavLink', undefined);
    }
    if (values.file) {
      setFieldValue('file', undefined);
    }
  };

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files && event.currentTarget.files[0];

    if (file) {
      console.log(getFileExtension(file));

      const extension = getFileExtension(file);

      if (extension !== 'wav' && extension !== 'flac')
        return toast.error(t('formik-error.invalid-file-extension'));

      setFieldValue('file', file);
      event.currentTarget.value = '';
    }
  };
  return (
    <div className='flex flex-col w-full gap-4'>
      <Container className='max-w-[900px] self-start'>
        <Container.Header
          title={
            <>
              <PiWaveform />
              {!values.file
                ? t('track.file.header')
                : t('track.file.addHeader')}
            </>
          }>
          {status?.displayMode ? null : (
            <div className='flex m-1 gap-1'>
              <Button
                isClear
                onlyIcon
                onClick={() => inputRef.current?.click()}>
                <Button.Icon icon={<PiFileAudio />} />
                <Button.Text text={t('button.addFile')} />
              </Button>
              <input
                ref={inputRef}
                className='hidden'
                type='file'
                onChange={onInputChange}
              />
              {(values.file || values.mp3PreviewLink) && (
                <Button
                  onlyIcon
                  isClear
                  disabled={!values}
                  variant={BUTTON_VARIANT.remove}
                  onClick={onDeleteTrack}>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </div>
          )}
        </Container.Header>

        <Container.Content className='flex flex-row justify-between items-center'>
          {!values.file ? (
            <AudioPlayer
              trackId={values.id}
              url={values.mp3PreviewLink ?? ''}
            />
          ) : (
            <div className='flex flex-col gap-3'>
              <LabeledValue label={t('track.file.name')}>
                {values.file?.name.split('.')[0]}
              </LabeledValue>
              <LabeledValue label={t('track.file.extension')}>
                {values.file?.name.split('.')[1]}
              </LabeledValue>
              <LabeledValue label={t('track.file.size')}>
                {readableFileSize(values.file?.size)}
              </LabeledValue>
              <LabeledValue label={t('track.file.lastModified')}>
                {values.file?.lastModified &&
                  format(new Date(values.file.lastModified), 'dd.MM.yyyy')}
              </LabeledValue>
            </div>
          )}
          {values.mp3PreviewLink && !values.file && (
            <div className='flex items-center flex-row gap-2'>
              {/* <a
                href={values.mp3Link}
                download={values.mp3Link}
                aria-disabled={!values.mp3Link}
                target='_blank'
                rel='noreferrer'>
                <Button type='button' isClear disabled={!values.mp3Link}>
                  <Button.Icon icon={<PiDownload />} />
                  <Button.Text text='Download' />
                </Button>
              </a> */}
              <MoleculeButton.AudioDownload
                isClear
                mp3Url={values.mp3Link}
                flacUrl={values.flacLink}
                wavUrl={values.wavLink}
                disabled={!values.wavLink && !values.mp3Link}
              />
            </div>
          )}
        </Container.Content>
      </Container>
    </div>
  );
};

export default TrackFile;
